// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ZaiFakeDoorModal-wrapper .textContent {
  padding: 32px;
}
.ZaiFakeDoorModal-wrapper p {
  font-size: 14px;
  color: var(--color_neutral_800);
  margin-top: 32px;
}
.ZaiFakeDoorModal-wrapper .buttonsSection {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 32px;
  width: 100%;
  border-top: 1px solid var(--color_neutral_200);
}
.ZaiFakeDoorModal-wrapper .buttonsSection [class^=dist_buttonStyle] {
  white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./src/contexts/ZaiChatContext/components/ZaiFakeDoorModal/index.scss"],"names":[],"mappings":"AACE;EACE,aAAA;AAAJ;AAGE;EACE,eAAA;EACA,+BAAA;EACA,gBAAA;AADJ;AAIE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,aAAA;EACA,WAAA;EACA,8CAAA;AAFJ;AAII;EACE,mBAAA;AAFN","sourcesContent":[".ZaiFakeDoorModal-wrapper {\n  .textContent {\n    padding: 32px;\n  }\n\n  p {\n    font-size: 14px;\n    color: var(--color_neutral_800);\n    margin-top: 32px;\n  }\n\n  .buttonsSection {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    padding: 32px;\n    width: 100%;\n    border-top: 1px solid var(--color_neutral_200);\n\n    [class^=\"dist_buttonStyle\"] {\n      white-space: nowrap;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
